import { StyleSheet } from "@react-pdf/renderer";
import colors from "core/resources/theme/colors";

export const commonRelatorioPdfStyles = StyleSheet.create({
  itemTableTitleRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 2,
  },
  itemTableTitle: {
    color: colors.black,
    fontWeight: "medium",
  },
  itemTableSummary: {
    borderTopColor: colors.black300,
    borderTopWidth: 1,
    paddingTop: 1,
    fontWeight: "medium",
  },
});